import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import { CHANGE_REFERRAL_DATA } from './types';

// FIXME this looks more like an entity
const referral = createReducer(
  {
    code: '',
    id: null,
    logo_url: '',
    name: '',
  },
  {
    [CHANGE_REFERRAL_DATA]: (draft, { payload }) => payload.referral,
  }
);

export default combineReducers({
  referral,
});
